import React, { useState, useEffect } from 'react';

import './ChannelListPopup.scss';

import Subscribe from '../../shared/assets/icons/subscribe.svg';

const autoSubscription = {
  PREGNANT: ['zwangerenportaal', 'magazine'],
  PARTNER: ['partnerchannel']
};

const recommendedChannels = {
  PREGNANT: [
    'week-recepten',
    'aanbiedingen-zwangerschapskleding',
    'quotes',
    'aanbiedingen',
    'onderzoeken',
    'vlogkanaal-sanne-bakker'
  ],
  PARTNER: ['papaklas', 'aanbiedingen', 'maartensnethlage', 'onderzoeken']
};

export default function ChannelListPopup(props) {
  const [isHide, setIsHide] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);

  useEffect(() => {
    props.getChannels({ variables: { channelLimit: 10 } });
  }, []);

  useEffect(() => {
    if (!isSubscribed && props.user.status) {
      (autoSubscription[props.user.status] || []).forEach((channelUri) =>
        props.subscribeChannel({ variables: { channelUri } })
      );

      setIsSubscribed(true);
    }
  }, [isSubscribed, props]);

  return isHide ? null : (
    <section className="channelListPopup">
      <form>
        <p className="channelListPopup_title">
          Volg kanalen om persoonlijk nieuws te kunnen ontvangen!
        </p>

        <ul className="channelListPopup_channels">
          {(recommendedChannels[props.user.status] || []).map((uri) => {
            const channel = props.channels.find(
              (channel) => channel.uri === uri
            );

            if (channel) return item(channel);
          })}

          {props.channels
            .filter(
              (channel) =>
                !(recommendedChannels[props.user.status] || []).includes(
                  channel.uri
                )
            )
            .slice(0, 10)
            .map((channel) => item(channel))}
        </ul>

        <input
          type="submit"
          value="Volgende"
          onClick={(e) =>
            !e.target.classList.contains('channelListPopup_button_disabled') &&
            hidePopup()
          }
          className="channelListPopup_button channelListPopup_button_disabled"
        />

        <p className="channelListPopup_skip_label" onClick={() => hidePopup()}>
          Overslaan
        </p>
      </form>
    </section>
  );

  function item(item) {
    return (
      <li key={item.id}>
        <div>
          <img alt="channel-image" src={item.imageUrl} />
        </div>

        <p>{item.displayName}</p>

        <div
          onClick={(e) => subscribe(e, item.uri)}
          className="channelListPopup_subscribe_button"
        >
          <Subscribe />
          Abonneer
        </div>
      </li>
    );
  }

  function subscribe(e, channelUri) {
    props.subscribeChannel({ variables: { channelUri } });

    e.target.classList.add('channelListPopup_subscribed_button');

    document
      .querySelector('.channelListPopup_button')
      .classList.remove('channelListPopup_button_disabled');
  }

  function hidePopup() {
    setIsHide(true);

    props
      .addUserEvent({ variables: { type: 'popup-close:channels', data: '{}' } })
      .then(() => props.metaRefetch());
  }
}
